export default __webpack_public_path__ + "static/se-194e794083226444594b34c527c57b10.svg";